Object.defineProperty(exports,"__esModule",{value:true});exports.powerStateDataForDevice=undefined;

var _types=require('./types');

var powerStateDataForDevice=exports.powerStateDataForDevice=function powerStateDataForDevice(securityDevice){
if(!securityDevice||!securityDevice.isSecurePlug()){
return{};
}var

powerOutEnabled=securityDevice.powerOutEnabled;

var type=powerOutEnabled?_types.powerState.POWERED:_types.powerState.UNPOWERED;

switch(type){
case _types.powerState.POWERED:
return{
powerStateType:_types.powerState.POWERED,
powerStateTitle:'Powered',
powerStateActionTitle:'Unpower',
powerStateActionTitleInProgress:'Unpowering',
powerStateAction:_types.positionAction.UNPOWER};

case _types.powerState.UNPOWERED:
return{
powerStateType:_types.powerState.UNPOWERED,
powerStateTitle:'Unpowered',
powerStateActionTitle:'Power',
powerStateActionTitleInProgress:'Powering',
powerStateAction:_types.positionAction.POWER};

default:
return{};}

};